module.exports = __webpack_public_path__ + "static/media/vermi_nutrition.b2252c03.png";